import React from 'react';
import { Activity, Microscope, ShieldCheck } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const InternalMedicinePage = () => {
  const config = {
    badge: "Internal Medicine",
    headline: "Systemic",
    headlineItalic: "Healing.",
    subtext: "Expert diagnosis and management of complex multi-system medical conditions, from metabolic disorders to gastrointestinal disease.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Internal Medicine at Dr. Suresh Pet Care — Systemic Medical Excellence",
    stats: [
      { value: 3000, suffix: '+', label: 'Medical Cases' },
      { value: 96, suffix: '%', label: 'Diagnostic Accuracy' },
      { value: 8, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Care' },
    ],
    services: [
      {
        title: "Endocrinology",
        icon: <Activity size={28} />,
        desc: "Comprehensive management of hormonal conditions including diabetes, Cushing's, and thyroid disorders.",
        specs: ["Diabetes Management", "Thyroid Disorders", "Cushing's Protocol", "Hormonal Panels"],
        color: "from-orange-500/10 to-primary/10"
      },
      {
        title: "Nephrology & Urology",
        icon: <Microscope size={28} />,
        desc: "Advanced kidney disease management, bladder stone removal, and urinary tract infection protocols.",
        specs: ["Kidney Function Tests", "Urinalysis", "Bladder Stone Protocol", "IV Fluid Therapy"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Gastroenterology",
        icon: <ShieldCheck size={28} />,
        desc: "Diagnosis and treatment of gastrointestinal disorders including IBD, pancreatitis, and GI obstruction.",
        specs: ["GI Endoscopy", "IBD Management", "Pancreatitis Protocol", "Dietary Counseling"],
        color: "from-green-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Medical",
    sectionItalic: "Specialties.",
    warningTitle: "Internal Medicine",
    warningItalic: "Warning Signs.",
    warningText: "Systemic diseases often progress silently. Regular clinical evaluation and blood work can detect conditions before they become critical.",
    warnings: [
      { name: "Excessive Thirst", desc: "Increased water intake can signal diabetes, kidney disease, or Cushing's.", icon: "💧" },
      { name: "Vomiting / Diarrhea", desc: "Persistent GI issues may indicate pancreatitis, IBD, or obstruction.", icon: "⚠️" },
      { name: "Weight Changes", desc: "Unexplained gain or loss is a common marker of metabolic or hormonal disease.", icon: "📊" },
      { name: "Lethargy", desc: "Reduced energy and exercise tolerance can signal anemia or organ dysfunction.", icon: "😴" },
    ],
    ctaBadge: "Internal Medicine",
    ctaTitle: "The Medical",
    ctaItalic: "Expertise.",
    ctaText: "Led by Dr. T Suresh Babu, our internal medicine unit deploys advanced diagnostics to resolve even the most complex multi-system conditions in Hyderabad.",
    ctaBtn: "Book Medical Consult",
    seoText: "Expert veterinary internal medicine in Hyderabad. Endocrinology, nephrology and gastroenterology for pets at Dr. Suresh Pet Care. Complex medical condition management.",
    glowColor: "orange-500"
  };

  return (
    <>
      <SEO 
        title="Veterinary Internal Medicine"
        description="Expert diagnosis and treatment of complex internal conditions in pets at Dr. Suresh Pet Care, Hyderabad. Specializing in endocrinology, nephrology and gastroenterology."
        canonical="/internal-medicine"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default InternalMedicinePage;
